import { Component, computed, effect, EventEmitter, inject, input, Input, OnInit, Output } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AccountingService } from '../../../_services/accounting/accounting.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-tracking-categories',
  imports: [NgSelectComponent, FormsModule, NgClass],
  templateUrl: './tracking-categories.component.html',
  standalone: true,
})
export class TrackingCategoriesComponent implements OnInit {
  accountingService = inject(AccountingService);

  // Use cached tracking categories from Store via service, sorted by id to keep
  // a stable, predictable order regardless of the order returned by the API.
  categoryOptions = computed(() => [...this.accountingService.trackingCategories()].sort((a, b) => a.id - b.id));
  disabled = input<boolean>(false);

  selectedValues: { [categoryId: number]: number } = {};

  @Input() component: string | undefined; // define component, used for conditional styling
  @Input() selectedTrackingCats: number[] = []; // Array of selected option IDs
  @Output() selectedTrackingCatsChange = new EventEmitter<number[]>();
  @Output() trackingCatCount = new EventEmitter<number>();

  constructor() {
    // Emit count when tracking categories are loaded from cache/API
    effect(() => {
      const categories = this.categoryOptions();
      if (categories && categories.length > 0) {
        this.trackingCatCount.emit(categories.length);
      }
    });
  }

  ngOnInit(): void {
    this.populateSelectedValues();
  }

  private populateSelectedValues(): void {
    // Populate selectedValues from array of option IDs
    if (this.selectedTrackingCats && this.selectedTrackingCats.length > 0) {
      const categories = this.categoryOptions();

      // For each selected option ID, find which category it belongs to
      this.selectedTrackingCats.forEach((optionId) => {
        categories.forEach((category) => {
          const option = category.options.some((opt) => opt.id === optionId);
          if (option) {
            this.selectedValues[category.id] = optionId;
          }
        });
      });
    }
  }

  onSelectionChange(): void {
    const payload = this.getPayload();
    this.selectedTrackingCatsChange.emit(payload);
  }

  getPayload(): number[] {
    return Object.values(this.selectedValues).filter((v) => v != null);
  }
}
